module.exports = __webpack_public_path__ + "assets/img/instagram.6e699147.svg";